import {post} from './http'
const baseUrl = '/api'

// 获取广告配置接口
export const getAdConfig = v => post(`${baseUrl}/capwhale/system/getAdConfig`, v.data, v.success, v.error)
// 个人中心
// 订单列表
export const getOrderList  = v => post(`${baseUrl}/capwhale/center/getAllOrders`, v.data, v.success, v.error)
// 订单详情
export const getOrderDetail  = v => post(`${baseUrl}/capwhale/center/getOrderDetail`, v.data, v.success, v.error)
// 取消订单
export const cancelMyOrderInfo  = v => post(`${baseUrl}/capwhale/center/cancelMyOrderInfo`, v.data, v.success, v.error)
// 收藏列表
export const getMyCollectlist  = v => post(`${baseUrl}/capwhale/center/getMyCollectlist`, v.data, v.success, v.error)
// 收藏列表
export const getMyFollowHostList  = v => post(`${baseUrl}/capwhale/center/getMyFollowHostList`, v.data, v.success, v.error)
// 学习列表
export const getUserJoinCourseList  = v => post(`${baseUrl}/capwhale/center/getUserJoinCourseList`, v.data, v.success, v.error)
// 获取用户基本信息
export const getUserCustomerInfo  = v => post(`${baseUrl}/capwhale/center/getUserCustomerInfo`, v.data, v.success, v.error)
// 获取用户基统计信息
export const getUserStatisticsInfo  = v => post(`${baseUrl}/capwhale/center/getUserStatisticsInfo`, v.data, v.success, v.error)
// 查询支付结果
export const queryorderpayresult  = v => post(`${baseUrl}/capwhale/pay/queryorderpayresult`, v.data, v.success, v.error)
// 绑定手机号
export const checkBindMobile  = v => post(`${baseUrl}/capwhale/user/checkBindMobile`, v.data, v.success, v.error)
// 获取作者
export const getIndexRecommAuthor  = v => post(`${baseUrl}/capwhale/course/index/getIndexRecommAuthor`, v.data, v.success, v.error)